import {NgModule} from '@angular/core';
import {MaterialModule} from '../../material.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {SharedModule} from '../../shared/shared.module';
import {INRComponent} from './pages/inr/inr.component';
import {INRRouterModule} from './inr.router';
import {INRPatientProfileComponent} from './pages/inr-patient-profile/inr-patient-profile.component';
import {InrPatientListComponent} from './pages/inr-patients-list/inr-patients-list.component';
import {InrPatientReportsComponent} from "./components/inr-patient-reports/inr-patient-reports.component";
import {InrPatientResultsComponent} from "./components/inr-patient-results/inr-patient-results.component";
import { InrNoteToPatientComponent } from './components/inr-note-to-patient/inr-note-to-patient.component';
import { InrPatientProfileComponentCard } from './components/inr-patient-profile-card/inr-patient-profile-component-card.component';
import { AssignPatientToInrModalComponent } from './components/assign-patient-to-inr-modal/assign-patient-to-inr-modal.component';

@NgModule({
  declarations: [INRComponent, INRPatientProfileComponent, InrPatientListComponent,
    InrPatientReportsComponent, InrPatientResultsComponent,
    InrNoteToPatientComponent, InrPatientProfileComponentCard,
    AssignPatientToInrModalComponent
  ],
  imports: [MaterialModule, SharedModule, INRRouterModule, ReactiveFormsModule, CommonModule, FormsModule,],
  exports: [INRRouterModule],
})
export class INRModule {

}
